module.exports = __webpack_public_path__ + "img/ItemMatrixFocused.53cceaf1.jpg";